const AdPlatforms = {
  msn: "msn",
  taboola: "taboola",
  advangelists: "advangelists",
  medianet: "medianet",
  gam: "gam",
};

export default AdPlatforms;
